// extracted by mini-css-extract-plugin
module.exports = {"documents":"Documents_documents__14pHY","column":"Documents_column__1fvxq","file":"Documents_file__1tNnT"};